import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Modal
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import ContactForm from './ContactForm';
import ContactTable from './ContactTable';
import ContactGrid from './ContactGrid';
import { ContactsContext } from './ContactsContext';
import Breadcrumb from './BreadcrumbsComponent';

import api, { consoleDevLog } from '../apiConfig';
import '../assets/styles/contacts.css';

function ContactsPage() {
  const [openModal, setOpenModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [view, setView] = useState('table');

  const { contacts, addContact, removeContact } = useContext(ContactsContext);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    consoleDevLog('Contacts updated:', contacts);
  }, [contacts]);

  const handleRemoveContact = async (indexToRemove) => {
    await api.delete(`/clients/${contacts[indexToRemove].id}`);
    removeContact(indexToRemove);
  };

  const handleEditContact = (contact) => {
    setSelectedContact(contact);
    setOpenModal(true);
  };

  const handleSaveContact = async (formData) => {
    if (selectedContact) {
      // Edit existing
      try {
        const response = await api.put(`/clients/${selectedContact.id}`, formData);
        const indexToRemove = contacts.findIndex((c) => c.id === selectedContact.id);
        if (indexToRemove !== -1) {
          removeContact(indexToRemove);
        }
        addContact(response.data);
      } catch (err) {
        console.error('Error updating contact:', err);
      }
    } else {
      // Create new
      try {
        const res = await api.post('/clients', formData);
        addContact(res.data);
      } catch (error) {
        console.error('Error creating contact:', error);
      }
    }
    setSelectedContact(null);
    setOpenModal(false);
  };

  return (
    <Container>
      <Grid container spacing={3}>
        <Breadcrumb />
      </Grid>

      <div style={{ marginBottom: '20px' }}></div>

      <div className="contacts-root">
        <Typography variant="h4" className="contacts-header">
          Client Contacts
        </Typography>

        <div className="view-switcher">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
            onClick={() => {
              setSelectedContact(null);
              setOpenModal(true);
            }}
          >
            Add Contact
          </Button>
          <Button variant="contained" onClick={() => setView('table')}>
            Table View
          </Button>
          <Button variant="contained" onClick={() => setView('grid')}>
            Grid View
          </Button>
        </div>

        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <div className="modal-content">
            <ContactForm
              closeForm={() => {
                setSelectedContact(null);
                setOpenModal(false);
              }}
              existingContact={selectedContact}
              onSaveContact={handleSaveContact}
              setView={setView}
              addContact={addContact}
            />
          </div>
        </Modal>

        <TextField
          label="Search Contacts"
          variant="outlined"
          fullWidth
          margin="normal"
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {view === 'table' && (
          <ContactTable
            searchTerm={searchTerm}
            contacts={contacts}
            removeContact={handleRemoveContact}
            onEditContact={handleEditContact}
          />
        )}

        {view === 'grid' && (
          <ContactGrid
            searchTerm={searchTerm}
            contacts={contacts}
            removeContact={handleRemoveContact}
            onEditContact={handleEditContact}
          />
        )}
      </div>
    </Container>
  );
}

export default ContactsPage;
